import feeManagement from "../../assets/modules/feeManagement.png";
import feeManagementMob from "../../assets/modules/feeManagementMob.png";

export const modules = {
  title: "Dynamic Academic ERP Modules",
  info: "Any educational institution can benefit from Dynamic Academic ERP. With this software, you can manage Academics, Accounts, GPS Tracking, HR & Payroll, and much more. We provide software that is very useful to the school management committee and other stakeholders such as teachers and parents. Such software helps schools run more efficiently and safely.Schools, colleges, and other educational institutions use Academic ERP, which has been trusted by more than 1500+ institutions.",
  solutions: [
    {
      id: "1",
      type: "Fees Management",
      images: {
        web: require("../../assets/modules/feesweb.png"),
        mobile: require("../../assets/modules/Feesmobile.png"),
      },
      preview:
        "Automates fees collection facilitatestransactions and provides in-depth financial reports School Fees management system to facilitate.",
      description:
        "Automates fees collection facilitates transactions and provides in-depth financial reports School Fees management system to facilitate and streamline fees collection and unpaid fees. Fee structures, customized reports, and fees receipts can be generated, and parents will be aware of fee dues instantly if fees are not paid. In addition to automating the calculation of fees, it reduces the risk of fraudulent transactions by being the safest and most convenient method of managing payments.",
      keyFeatures: {
        title: "An educational fee management system's features ",
        features: (
          <>
            <li>{"Management of all fees "}</li>
            <li>{"Making Advance Fee Payments"}</li>
            <li>{"Online payment and fee avoiders"}</li>
            <li>{"Reports on fees & other finances"}</li>
            <li>{"Calculation of Instant Discounts & Taxes"}</li>
          </>
        ),
      },
    },
    {
      id: "20",
      type: "Online Class",
      images: {
        web: require("../../assets/modules/OnlineClassweb.png"),
        mobile: require("../../assets/modules/OnlineClassmobile.png"),
      },
      preview:
        "We make online learning possible more than 1500+ institutions. Using our dynamic academic ERP we facilitate online teaching & learning efficiently.",
      description:
        "We make online learning possible at more than 1500+ institutions. Using our dynamic academic ERP, we facilitate online teaching and learning efficiently.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"Integrated zoom for online classes"}</li>
            <li>{"Class Assignments"}</li>
            <li>{"Auto Attendance"}</li>
            <li>{"Subjective and Objective tests"}</li>
            <li>{"Integrated video conferencing Google Meet"}</li>
          </>
        ),
      },
    },
    {
      id: "5",
      type: "Academic with LMS",

      images: {
        web: require("../../assets/modules/Academic.png"),
        mobile: require("../../assets/modules/AcademicMobile.png"),
      },
      preview:
        "Instructors can manage and distribute teaching resources, such as videos, instruction courses and learning documents.",
      description:
        "With a single platform from anywhere, you can create and manage your school digitally.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"Receipt and payment"}</li>
            <li>{"Ledger/Ledger group/Multiple ledgers"}</li>
            <li>{"Cash flow"}</li>
            <li>{"Trial balance"}</li>
            <li>{"Balance sheet"}</li>
            <li>{"Ratio Analysis"}</li>
            <li>{"Profit and loss"}</li>
            <li>{"Bank Reconciliation"}</li>
            <li>{"Interest calculation and checkbook"}</li>
            <li>{"Daybook & pending voucher"}</li>
          </>
        ),
      },
    },

    {
      id: "4",
      type: "Exam Management",
      images: {
        web: require("../../assets/modules/Examweb.png"),
        mobile: require("../../assets/modules/Exammobile.png"),
      },
      preview:
        "Students' progress can be tracked through online exams, customized report cards, and custom report cards. ",
      description:
        "Students' progress can be tracked through online exams, customized report cards, and custom report cards. Moreover, schools can conduct descriptive & objective exams, stop printing report cards, reduce administrative burden, & get instant feedback on students' progress.",
      keyFeatures: {
        title: "Features of examination management systems",
        features: (
          <>
            <li>{"Management of exams"}</li>
            <li>{"Detailed Reports"}</li>
            <li>{"Managing Grade book"}</li>
          </>
        ),
      },
    },
    {
      id: "8",
      type: "Account Management",
      images: {
        web: require("../../assets/modules/Accountingweb.png"),
        mobile: require("../../assets/modules/Accountingmobile.png"),
      },
      preview:
        "Handle journals, ledgers, trial balances, balance sheets, cash flows, and audit reports efficiently and accurately",
      description:
        "Handle journals, ledgers, trial balances, balance sheets, cash flows, and audit reports efficiently & accurately. Increase the efficiency of the institutions' finances.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"Cash payments and receipts"}</li>
            <li>{"Journal, Ledger, and Trial balance"}</li>
            <li>{"Balance sheet"}</li>
            <li>{"Income & Expenditure"}</li>
            <li>{"Audit reports"}</li>
          </>
        ),
      },
    },

    {
      id: "2",
      type: "Management of timelines",
      images: {
        web: require("../../assets/modules/timelinesweb.png"),
      },
      description:
        "We have helped schools and colleges of different sizes in managing timetables efficiently by saving time and effort and generating an error-free timetable. A single click enables an administrator to appoint an additional teacher to the class in the case of an absence. This automates the timetable management system, simplifying payroll calculation & promoting a paperless environment.",
      keyFeatures: {
        title: "Features of Timetable Management ",
        features: (
          <>
            <li>{"Timetables can be scheduled and managed easily"}</li>
            <li>{"Easily assign subjects to teachers."}</li>
            <li>
              {
                "For different types of periods, create different class timing sets."
              }
            </li>
            <li>{"Managing classroom placement is easy"}</li>
            <li>
              {
                "A teacher's timetable can be accessed from his or her login, allowing them to plan accordingly."
              }
            </li>
            <li>
              {
                "Send instant email notifications to teachers when transferring classes."
              }
            </li>
            <li>
              {
                "The schedule for all classes for any term can be efficiently determined by an administrator."
              }
            </li>
          </>
        ),
      },
    },
    {
      id: "3",
      type: "Individual Remarks",
      images: {
        web: require("../../assets/modules/individual.png"),
      },
      description:
        "The following remarks are common, subject-specific, & exam-specific.According to their individual performances on exams, terms, or in a subject,educators can add, delete, or edit remarks for each student. Teachers can use the Custom student remarks module to send parents instant alerts on how a student's performance can be improved using constructive feedback.Student remark features in school ERP",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>
              {
                "Give general remarks about how each student performed on each subject"
              }
            </li>
            <li>
              {"Describe a typical student's performance on a particular exam."}
            </li>
            <li>
              {
                "Describe the daily activities of students using custom remarks."
              }
            </li>
            <li>
              {
                "For the daily update, students/parents can see the comments on their profiles."
              }
            </li>
            <li>
              {
                "The Manage Remarks page allows you to append remarks to students."
              }
            </li>
          </>
        ),
      },
    },

    {
      id: "6",
      type: "Library Management",
      images: {
        web: require("../../assets/modules/Library.png"),
      },
      description:
        "You can track the book's status and efficiently organize the book information present in the library.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"E Library & Book Order"}</li>
            <li>{"Complete Track of Book"}</li>
            <li>{"Library fine e-receipt"}</li>
            <li>{"Online Book renewal"}</li>
            <li>{"Transaction & return report"}</li>
          </>
        ),
      },
    },
    {
      id: "7",
      type: "Transportation Management",
      images: {
        web: require("../../assets/modules/Transportationweb.png"),
        mobile: require("../../assets/modules/Transportationmobile.png"),
      },
      description:
        "Collecting transportation fees and managing schedules has never been easier. The system makes all these tasks simple and intuitive. With GPS tracking and navigation, students and drivers are more secure than ever",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{" Route Schedule and student mapping"}</li>
            <li>{"GPS tracking of vehicle and CC Camera"}</li>
            <li>{"Manage transport expenses and Fee collection"}</li>
            <li>{"Vehicle profile manager"}</li>
            <li>{"Instant SMS alerts"}</li>
          </>
        ),
      },
    },

    {
      id: "9",
      type: "SMS Management",
      images: {
        web: require("../../assets/modules/SMSweb.png"),
        mobile: require("../../assets/modules/SMSmobile.png"),
      },
      description:
        "Ensure that parents are kept updated on their children's progress. Instantly notify students of holidays, exams, fee reminders, and other events.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"Fee Alerts"}</li>
            <li>{"Result Alerts"}</li>
            <li>{"News/ Information alerts"}</li>
            <li>{"Holiday information"}</li>
            <li>{"Urgent alert to parents/students"}</li>
          </>
        ),
      },
    },
    {
      id: "10",
      type: "User Management",
      images: {
        web: require("../../assets/modules/User.png"),
      },
      description:
        "Assuring the highest level of security for each user provide each with their own login credentials. Assigning different access levels to different features/modules.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"Username & Password generation"}</li>
            <li>{"Set users' access level control"}</li>
            <li>{"Grant special permission"}</li>
            <li>{"Edit user details & reset password"}</li>
            <li>{"Block any user"}</li>
          </>
        ),
      },
    },
    {
      id: "11",
      type: "HR & Payroll Management",
      images: {
        web: require("../../assets/modules/HR.png"),
      },
      description:
        "One platform to manage employee details, such as their profile, attendance, salary, deductions, and leaves.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"Employee profile management"}</li>
            <li>{"Salary calculation automation"}</li>
            <li>{"Employee summary and reports"}</li>
            <li>{"Loan/Interest management"}</li>
            <li>{"Account module integration"}</li>
          </>
        ),
      },
    },
    {
      id: "12",
      type: "Hostel Management",
      images: {
        web: require("../../assets/modules/Hostelweb.png"),
        mobile: require("../../assets/modules/Hostelmobile.png"),
      },
      description:
        "Manage and administrate all hostel details effectively. It is easy to assign students to the hostels and maintain hostel records as well as pay hostel bills.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"Boarder’s Student details"}</li>
            <li>{"Boarders Type"}</li>
            <li>{"Manage room details"}</li>
            <li>{"Allocate rooms to students"}</li>
            <li>{"Students Fees Collection"}</li>
          </>
        ),
      },
    },
    {
      id: "13",
      type: "Front Desk",
      images: {
        web: require("../../assets/modules/Front.png"),
      },
      description:
        "Front Desk functionality in Dynamic Academic ERP manages the requirements of a school/college reception area. By using this software, you can control the Front Office Process with minimal effort and change your working method to a flexible, and paperless method.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"Admission Enquiry Management"}</li>
            <li>{"Follow Up"}</li>
            <li>{"Seat Allotment"}</li>
            <li>{"Pre-admission"}</li>
            <li>{"Visitor Book"}</li>
            <li>
              {
                "Create a gate pass with dates, times, names, mobile numbers, and addresses"
              }
            </li>
            <li>
              {
                "Phone call log - record call details and numbers of incoming and outgoing calls."
              }
            </li>
            <li>
              {"Postal Services - Keep records of all Received/dispatched."}
            </li>
            <li>{"Create New Employee Applicationk"}</li>
            <li>{"Manage Complain"}</li>
          </>
        ),
      },
    },
    {
      id: "14",
      type: "App CMS",
      images: {
        web: require("../../assets/modules/App.png"),
      },
      description:
        "Schools/colleges can use a CMS that delivers high-performance applications built on a java-based framework, which offers flexibility, ease of use, and a seamless experience for teachers, parents, and students.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"The drag-and-drop functionality"}</li>
            <li>{"Verification Checker"}</li>
            <li>{"Controlling access to resources"}</li>
            <li>{"Managing images"}</li>
            <li>{"Photo Gallery"}</li>
            <li>{"Process for Content Approval"}</li>
            <li>{"Filter, merge, and search calendars"}</li>
          </>
        ),
      },
    },
    {
      id: "15",
      type: "Academic Calendar",
      images: {
        web: require("../../assets/modules/Calendar.png"),
      },
      description:
        "Manage the academic calendar of schools/colleges and display events and exams in the schools/college's calendar.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"Manage event type efficiently."}</li>
            <li>{"Properly categorize event list."}</li>
            <li>{"Manage weekend activities"}</li>
            <li>{"Setup/Manage schools/colleges Calendar."}</li>
          </>
        ),
      },
    },
    {
      id: "16",
      type: "Canteen Management",
      images: {
        web: require("../../assets/modules/Canteen.png"),
      },
      description:
        "Academics ERP Software provides a system that helps you manage the canteen effectively at your school/college. As a result, the workload for staff is reduced, paperwork is reduced, and students' records, meals, breakfast, and other necessities are all kept up to date.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"Create canteen"}</li>
            <li>{"Food category"}</li>
            <li>{"Food creation"}</li>
            <li>{"Time slot master"}</li>
            <li>{"Stock management"}</li>
            <li>{"Records of consumption"}</li>
          </>
        ),
      },
    },
    {
      id: "17",
      type: "Inventory Management",
      images: {
        web: require("../../assets/modules/Inventory.png"),
      },
      description:
        "Instructors can manage and distribute teaching resources, such as videos instruction courses & learning documents with the help of a dynamic academic ERP.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"Provide a wide range of lesson formats"}</li>
            <li>{"Online forums for discussion"}</li>
            <li>{"Grading systems"}</li>
            <li>{"Online learning support"}</li>
            <li>{"Set up online quizzes"}</li>
            <li>{"Grade books"}</li>
          </>
        ),
      },
    },
    {
      id: "18",
      type: "Homework and Assignment",
      images: {
        web: require("../../assets/modules/Homework.png"),
      },
      description:
        "Schools/colleges can assign assignments & homework daily or at any time. Our academic ERP simplifies the process and makes it more convenient.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>
              {"Students can receive assignments individually or in groups."}
            </li>
            <li>
              {
                "Add assignments and homework class, section, teacher, and subjectwise"
              }
            </li>
          </>
        ),
      },
    },
    {
      id: "19",
      type: "Attendance Management",
      images: {
        web: require("../../assets/modules/Attendance.png"),
      },
      description:
        "Schools/Colleges face additional problems and errors, especially if they have to manage the daily attendance of students across a whole class, section, or academic year. In order to manage daily classroom attendance smoothly, it is important to replace the traditional manual approach with an automated one.",
      keyFeatures: {
        title: "",
        features: (
          <>
            <li>{"Attendance reports"}</li>
            <li>
              {
                "Manage students/staff leave according to type, quota, opening, and request."
              }
            </li>
            <li>{"Enroll students and employee number"}</li>
            <li>{"Create and map working shift"}</li>
          </>
        ),
      },
    },
  ],
};
